var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2C9.7 2 9 2.7 9 3.5S9.7 5 10.5 5h2.4l-3 2.9c-.6.6-.6 1.5 0 2.1.6.6 1.5.6 2.1 0l3-2.9v2.4c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V2h-7.5zM8.5 19c.8 0 1.5-.7 1.5-1.5S9.3 16 8.5 16H6.1L9 13.1c.6-.6.6-1.5 0-2.1-.6-.6-1.5-.6-2.1 0L4 13.9v-2.4c0-.8-.7-1.5-1.5-1.5S1 10.7 1 11.5V19h7.5z"
  })));
};
export default SvgExpand;